import Services from './services';

export function logTabView(containerSection, logData) {
  if (!containerSection) {
    return;
  }

  const mergedLogData = { ...logData, tab: containerSection };

  Services.logExploreTabView(mergedLogData);
}

const loadingNavId = 'explore-loading-nav';
const loadingFeedId = 'explore-loading-feed';

function toggleDisplay(id, show) {
  const loadingState = document.getElementById(id);
  if (loadingState) {
    loadingState.style.display = show ? 'block' : 'none';
  }
}

export function hideLoadingNav() {
  toggleDisplay(loadingNavId, false);
}

export function showLoadingNav() {
  toggleDisplay(loadingNavId, true);
}

export function hideLoadingFeed() {
  toggleDisplay(loadingFeedId, false);
}

export function showLoadingFeed() {
  toggleDisplay(loadingFeedId, true);
}
